/* Extra company fields printed on the Tax Invoice + EDF bank list (AD code). */
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const INVOICE_FIELDS = [
  ["phone", "Phone"], ["email", "Email"], ["pan", "PAN"], ["dl_no", "DL No."], ["lut_no", "LUT No."],
  ["payment_terms", "Payment terms (default ADVANCE PAYMENT)"], ["port_of_loading", "Port of loading (default MUMBAI)"],
  ["bank_name", "Bank name"], ["bank_branch", "Bank branch"], ["bank_account", "Bank A/C No."], ["bank_ifsc", "IFSC"],
];

export const invoiceFieldsOf = (c) => ({
  ...Object.fromEntries(INVOICE_FIELDS.map(([k]) => [k, (c && c[k]) || ""])),
  banks: (c && c.banks) || [],
});

const newId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now()));

const EdfBanks = ({ form, setForm }) => {
  const banks = form.banks || [];
  const set = (i, k, v) => setForm({ ...form, banks: banks.map((b, j) => (j === i ? { ...b, [k]: v } : b)) });
  return (
    <div className="mt-3" data-testid="mc-edf-banks">
      <div className="mb-1 flex items-center justify-between">
        <p className="text-xs font-semibold text-indigo-700">EDF banks (AD code) — picked from a dropdown on each EDF</p>
        <button type="button" className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-600 hover:underline"
          onClick={() => setForm({ ...form, banks: [...banks, { id: newId(), name: "", address: "", ad_code: "" }] })}
          data-testid="mc-bank-add"><Plus className="h-3 w-3" /> Add bank</button>
      </div>
      {banks.length === 0 && <p className="text-[11px] text-slate-400">No banks yet.</p>}
      {banks.map((b, i) => (
        <div key={b.id} className="mb-1.5 grid grid-cols-[1fr_1.4fr_0.8fr_auto] gap-1.5" data-testid={`mc-bank-row-${i}`}>
          <Input placeholder="Bank name" value={b.name} onChange={(e) => set(i, "name", e.target.value)} data-testid={`mc-bank-name-${i}`} />
          <Input placeholder="Branch address" value={b.address} onChange={(e) => set(i, "address", e.target.value)} data-testid={`mc-bank-address-${i}`} />
          <Input placeholder="AD code" value={b.ad_code} onChange={(e) => set(i, "ad_code", e.target.value)} data-testid={`mc-bank-adcode-${i}`} />
          <button type="button" className="px-1 text-rose-500" onClick={() => setForm({ ...form, banks: banks.filter((_, j) => j !== i) })}
            data-testid={`mc-bank-del-${i}`}><Trash2 className="h-4 w-4" /></button>
        </div>))}
    </div>
  );
};

export const CompanyInvoiceFields = ({ form, setForm }) => (
  <div className="mt-2 border-t border-dashed border-slate-300 pt-3" data-testid="mc-invoice-fields">
    <p className="mb-2 text-xs font-semibold text-indigo-700">Tax Invoice details</p>
    <div className="grid grid-cols-2 gap-2">
      {INVOICE_FIELDS.map(([k, label]) => (
        <div key={k}>
          <Label className="text-xs font-medium text-slate-600">{label}</Label>
          <Input value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`mc-${k}-input`} />
        </div>))}
    </div>
    <EdfBanks form={form} setForm={setForm} />
  </div>
);
